import {ConfirmationDialog} from '@primer/react'

import styles from './RebaseStackConfirmationDialog.module.css'

/**
 * The in-app confirmation shown before a stack rebase runs. Triggers the rebase on confirm.
 *
 * Presentational: the parent owns the trigger button, the open state, and the actual rebase
 * mutation. Base branches that require signed commits must rebase from the command line, so
 * that CLI flow is handled separately by the caller rather than here.
 */
export function RebaseStackConfirmationDialog({
  outOfDateCount,
  onConfirm,
  onClose,
}: {
  outOfDateCount: number
  onConfirm: () => void
  onClose: () => void
}) {
  return (
    <ConfirmationDialog
      className={styles.RebaseConfirmationDialog}
      title="Rebase stack"
      onClose={gesture => {
        if (gesture === 'confirm') {
          onConfirm()
        }
        onClose()
      }}
      confirmButtonContent={`Rebase ${outOfDateCount} pull request${outOfDateCount === 1 ? '' : 's'}`}
      confirmButtonType="primary"
    >
      <p className="mb-2">
        This will update {outOfDateCount} out-of-date pull request{outOfDateCount === 1 ? '' : 's'} in this stack:
      </p>
      <ul className="pl-4">
        <li>Each pull request will be rebased on top of the latest changes from its base branch</li>
        <li>The rebased branches will be force pushed to update the remote</li>
      </ul>
      <p className="mt-2">
        <a href="https://github.github.com/gh-stack/guides/workflows/#making-mid-stack-changes">
          Learn more about rebasing a stack
        </a>
      </p>
    </ConfirmationDialog>
  )
}
